import { useState } from 'react'
import debounce from 'lodash.debounce'

interface ChildProps<TData> {
  readonly filtered: TData[]
  readonly onSearch: (value: string) => void
}

type FilterFn<TData> = (item: TData, value: string) => boolean

interface Props<TData> {
  readonly data: TData[]
  readonly filterFns: Array<FilterFn<TData>>
  readonly children: (props: ChildProps<TData>) => JSX.Element
}

export function GenericFilterer<TData>({
  data,
  children,
  filterFns
}: Props<TData>) {
  const [searchText, setSearchText] = useState('')

  const filtered =
    searchText.trim() !== ''
      ? searchFilter<TData>(filterFns, data, searchText)
      : data

  return children({
    filtered,
    onSearch: debounce(setSearchText, 500)
  })
}

function searchFilter<TData>(
  configs: Array<FilterFn<TData>>,
  data: TData[],
  value: string
) {
  let combined: TData[] = []

  configs.forEach((filterFn) => {
    const filtered = data.filter((item) => filterFn(item, value))
    combined = combined.concat(filtered)
  })

  const unique = new Set(combined)
  return Array.from(unique.values())
}
